import { render } from "./LaChines.vue?vue&type=template&id=35e332e6&scoped=true"
import script from "./LaChines.vue?vue&type=script&lang=js"
export * from "./LaChines.vue?vue&type=script&lang=js"

import "./LaChines.vue?vue&type=style&index=0&id=35e332e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35e332e6"]])

export default __exports__